import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { transformSucessResponse, transformErrorResponse } from "../../utils/API/responseMiddleware";
import { transformRequest, encryptQueryString } from "../../utils/API/requestMiddleware"
import { customFetchBase } from '../../utils/API/fetchBaseQuery';

const skillCategoriesAPI = createApi({
    reducerPath: 'skillCategoriesAPI',
    baseQuery: customFetchBase,
    endpoints: (builder) => ({

        //**  AddEdit API */
        addEditSkillCategories: builder.mutation({
            query: (Details) => ({
                url: '/SkillCategories/AddEditSkillCategories',
                method: 'POST',
                body: transformRequest(Details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        //**  List API */
        getSkillCategories: builder.mutation({
            query: (userQuery) => ({
                url: '/SkillCategories/GetSkillCategories',
                method: 'POST',
                body: transformRequest(userQuery)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        //**  GetByID API */
        getSkillCategoriesById: builder.query({
            query: (skillCategoriesId) => ({
                url: encryptQueryString(`/SkillCategories/GetSkillCategoriesById/?skillCategoriesId=${Number(skillCategoriesId)}`),
                method: 'GET',
            }),
 
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        //** Delete API */
        deleteSkillCategories: builder.mutation({
            query: (skillCategoriesId) => ({
                url: `/SkillCategories/DeleteSkillCategories/?skillCategoriesId=${skillCategoriesId}`,
                method: 'DELETE',
                body: transformRequest(skillCategoriesId)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getAllSkillCategories: builder.query({
            query: () => ({
                url: `/SkillCategories/GetAllSkillCategories`,
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        getAllMainSkillByCategoriesId: builder.query({
            query: (skillCategoriesId) => ({
                url: `/Skill/GetAllMainSkillByCategoriesId/?skillCategoriesId=${skillCategoriesId}`,
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        getAllSubSkillByMainSkillId: builder.query({
            query: (mainSkillId) => ({
                url: `/Skill/GetAllSubSkillByMainSkillId/?mainSkillId=${mainSkillId}`,
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        addJobSkillCategories: builder.mutation({
            query: (Details) => ({
                url: '/Job/AddJobSkillCategories',
                method: 'POST',
                body: transformRequest(Details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        addJobMainSkill: builder.mutation({
            query: (Details) => ({
                url: '/Job/AddJobMainSkill',
                method: 'POST',
                body: transformRequest(Details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        addJobSubSkill: builder.mutation({
            query: (Details) => ({
                url: '/Job/AddJobSubSkill',
                method: 'POST',
                body: transformRequest(Details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        getJobSkillById: builder.query({
            query: (positionAppliedId) => ({
                url: `/Job/GetJobSkillById/?positionAppliedId=${positionAppliedId}`,
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        deleteJobSkillCategories: builder.mutation({
            query: (data) => ({
                url: `/Job/DeleteJobSkillCategories/?positionAppliedSkillCategoriesId=${data.positionAppliedSkillCategoriesId}&positionAppliedId=${data.positionAppliedId}`,
                method: 'DELETE',
                body: transformRequest(data)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        deleteJobMainSkill: builder.mutation({
            query: (data) => ({
                url: `/Job/DeleteJobMainSkill/?skillCategoriesMainSkillsId=${data.skillCategoriesMainSkillsId}&positionAppliedId=${data.positionAppliedId}`,
                method: 'DELETE',
                body: transformRequest(data)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        deleteJobSubSkill: builder.mutation({
            query: (data) => ({
                url: `/Job/DeleteJobSubSkill/?mainSkillsSubSkillsId=${data.mainSkillsSubSkillsId}&positionAppliedId=${data.positionAppliedId}`,
                method: 'DELETE',
                body: transformRequest(data)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        updateSubSkillDetails: builder.mutation({
            query: (Details) => ({
                url: '/Job/UpdateSubSkillDetails',
                method: 'POST',
                body: transformRequest(Details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

    })
})

export const {  useAddEditSkillCategoriesMutation,useGetSkillCategoriesMutation,useLazyGetSkillCategoriesByIdQuery,
    useDeleteSkillCategoriesMutation,useLazyGetAllSkillCategoriesQuery,useLazyGetAllMainSkillByCategoriesIdQuery,useLazyGetAllSubSkillByMainSkillIdQuery,useAddJobSkillCategoriesMutation,
    useAddJobMainSkillMutation,useAddJobSubSkillMutation,useLazyGetJobSkillByIdQuery,useDeleteJobSkillCategoriesMutation,useDeleteJobMainSkillMutation,useDeleteJobSubSkillMutation,useUpdateSubSkillDetailsMutation} = skillCategoriesAPI;

export default skillCategoriesAPI;